// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#app{font-family:roboto,sans-serif;color:#333}.v-application--wrap{min-height:auto!important}", ""]);
// Exports
module.exports = exports;
